import React from 'react'

const LoadRegistration = () => {

    const [data, setData] = React.useState(null);

    const getData = async () => {

        fetch('https://script.google.com/macros/s/AKfycbxvOi1y2SpMqRssJhpa2dKgzd_k9reXEoNCtW0i086kSGQDq5nchndK7HioiJAo4xit3A/exec', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                action: "read",
            })
        })
            .then(response => response.json())
            .then((res) => {
                setData(res.data || []);
                console.log("Load DataRegistration Success")
            })
            .catch(error => console.error('Error!', error.message));

    }
    React.useEffect(() => {
        if (data === null) {
            getData()
        };
    }, [data]);

    return data

}

export default LoadRegistration
